module.exports = __webpack_public_path__ + "img/i_homework-not-checked.9c9a83af.svg";